import React from 'react';
import { Helmet } from 'react-helmet-async';
import { 
  siteConfig, 
  getOrganizationStructuredData, 
  getWebsiteStructuredData, 
  getLocalBusinessStructuredData 
} from '../utils/seoConfig';

const SEOHelmet = ({ 
  title, 
  description, 
  keywords, 
  canonical, 
  image,
  type = 'website',
  includeOrganizationData = false,
  includeLocalBusinessData = false
}) => {
  const fullTitle = title ? `${title}` : siteConfig.siteName;
  const fullDescription = description || siteConfig.defaultDescription;
  const fullKeywords = keywords || siteConfig.defaultKeywords;
  const canonicalUrl = `${siteConfig.siteUrl}${canonical || ''}`;
  const imageUrl = image ? `${siteConfig.siteUrl}${image}` : `${siteConfig.siteUrl}${siteConfig.logo}`;

  // 結構化資料陣列
  const structuredData = [];
  
  // 網站基本結構化資料
  structuredData.push(getWebsiteStructuredData());
  
  if (includeOrganizationData) {
    structuredData.push(getOrganizationStructuredData());
  }
  
  if (includeLocalBusinessData) {
    structuredData.push(getLocalBusinessStructuredData());
  }

  return (
    <Helmet>
      {/* 基本 Meta 標籤 */}
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      <meta name="keywords" content={fullKeywords} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content={siteConfig.siteName} />
      <meta property="og:locale" content="zh_TW" />

      {/* Twitter Card */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={fullDescription} />
      <meta property="twitter:image" content={imageUrl} />

      {/* 其他重要 Meta 標籤 */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="author" content={siteConfig.siteName} />
      <meta name="language" content="zh-TW" />
      <meta name="geo.region" content="TW" />
      <meta name="geo.country" content="Taiwan" />

      {/* 結構化資料 */}
      {structuredData.map((data, index) => (
        <script 
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
      ))}
    </Helmet>
  );
};

export default SEOHelmet; 